module.exports = __webpack_public_path__ + "static/media/archiveIcon.037b301d.svg";